import * as React from 'react';
import { ReactNode } from 'react';
import { Group } from '../Group/Group';
import { Industry } from '../Model/Industry';
import { JobCenterModelInterface } from '../Model/JobCenterModelInterface';
import { StaticSettings } from '../StaticSettings';

type RenderItemCallback<T> = (item: T) => ReactNode;

export interface GroupProps<T> {
    group: Group<Industry, T>
    renderItem: RenderItemCallback<T>
    renderHeader: () => ReactNode
}

export class GroupComponent<T extends JobCenterModelInterface> extends React.PureComponent<GroupProps<T>> {
    public render() {
        const group = this.props.group;
        const renderItem = this.props.renderItem;

        return <div>
            <h2>{group.key.name}</h2>
            <ul>
                {this.renderHeader()}
                {group.items.map(i => <li key={i.referenceId}>{renderItem(i)}</li>)}
            </ul>
        </div>;
    }

    private renderHeader() {
        return StaticSettings.ui.list.showHeader ? <li>{this.props.renderHeader()}</li> : null;
    }
}
